import React from "react";
import Img from "./basic/Img";

const footerPng = "./assets/footer_text.png";
const footerPng2x = "./assets/footer_text@2x.png 2x";

function Footer() {
    return (
        <footer>
            <div className="footer-logo">
                <a href="https://www.bunshun.co.jp/" target="_blank">
                    <img src={footerPng} srcSet={footerPng2x} />
                </a>
            </div>
        </footer>
    );
}

export default Footer;
